import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=013fb28d"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013fb28d')) {
      api.createRecord('013fb28d', component.options)
    } else {
      api.reload('013fb28d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=013fb28d", function () {
      api.rerender('013fb28d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/coupon-owners/edit.vue"
export default component.exports